import { bakersfieldFilmFestival as bakersfieldFilmFestivalBase } from "@thirdparty/companies";

import { CustomApp } from "../../types";
import { fizz } from "../fizz";

export const bakersfieldFilmFestival: CustomApp = {
  ...bakersfieldFilmFestivalBase,
  routes: fizz.routes,
};
